import {useEffect, useState} from "react";

export function useOrientation() {
  const [isLandscape, setIsLandscape] = useState(
    window.matchMedia("(orientation: landscape)").matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: landscape)");

    const handler = (e: any) => setIsLandscape(e.matches)

    mediaQuery.addEventListener("change", handler)

    return () => mediaQuery.removeEventListener("change", handler)
  }, [])

  return isLandscape ? "landscape" : "portrait"
}